var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fx fx-c_stretch "},[_c('div',{staticClass:"fx-g1 edit_panel"},[_c('el-collapse',[_c('div',{staticStyle:{"text-align":"center","margin-top":"5px"},domProps:{"innerHTML":_vm._s(_vm.agentInfo.content)}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }